import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { BUSINESS } from "@/lib/content";

const Part = ({ title, children }) => (
  <section className="space-y-2">
    <h4 className="font-display text-lg text-cyan-200">{title}</h4>
    <div className="text-sm text-slate-300 leading-relaxed space-y-1">{children}</div>
  </section>
);

export default function LegalDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-sm text-slate-300 hover:text-cyan-300 underline underline-offset-4 transition-colors duration-300" data-testid="footer-legal-mentions-btn">
          Mentions légales & confidentialité
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#0c1222] border-cyan-300/20 text-white" data-lenis-prevent data-testid="legal-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Mentions légales</DialogTitle>
        </DialogHeader>
        <div className="space-y-6 pt-2">
          <Part title="Éditeur du site">
            <p>{BUSINESS.name} - nom commercial de {BUSINESS.owner}, entrepreneur individuel (micro-entreprise).</p>
            <p>SIRET : {BUSINESS.siret}</p>
            <p>Adresse : {BUSINESS.address}</p>
            <p>Téléphone : {BUSINESS.phone}</p>
            <p>Email : {BUSINESS.email}</p>
            <p>TVA non applicable, art. 293 B du CGI.</p>
            <p>Directeur de la publication : {BUSINESS.owner}.</p>
          </Part>
          <Part title="Hébergement">
            <p>[Nom, adresse et téléphone de l'hébergeur du site]</p>
          </Part>
          <Part title="Propriété intellectuelle">
            <p>L'ensemble des contenus du site (textes, logo, éléments graphiques) est la propriété de {BUSINESS.name}, sauf mention contraire. Toute reproduction sans autorisation est interdite.</p>
          </Part>
          <Part title="Données personnelles (RGPD)">
            <p>Les informations saisies dans le formulaire de devis (nom, prénom, téléphone, email, adresse du chantier, message) sont collectées par {BUSINESS.owner} dans le seul but de répondre à votre demande et d'établir un devis. Elles ne sont ni vendues ni cédées à des tiers.</p>
            <p>Elles sont conservées au maximum 3 ans à compter du dernier contact. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition en écrivant à {BUSINESS.email}. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).</p>
          </Part>
          <Part title="Médiation de la consommation">
            <p>Conformément à l'article L.612-1 du Code de la consommation, le client consommateur peut recourir gratuitement à un médiateur : [Nom et coordonnées du médiateur de la consommation].</p>
          </Part>
          <Part title="Responsabilité">
            <p>Les informations présentes sur ce site sont fournies à titre indicatif. Les demandes envoyées via le formulaire ne constituent pas un devis contractuel ; seul le devis signé engage les parties.</p>
          </Part>
        </div>
      </DialogContent>
    </Dialog>
  );
}
